import { Component, OnInit, Input, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { MenuService } from '../menu.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-horizontal-menu',
    templateUrl: './horizontal-menu.component.html',
    styleUrls: ['./horizontal-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MenuService]
})
export class HorizontalMenuComponent implements OnInit, OnDestroy
{

    private subscriptions: Subscription[] = [];
    @Input('menuParentId') menuParentId;
    public menuItems: Array<any>;
    public settings: Settings;
    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
    constructor(public appSettings: AppSettings, public menuService: MenuService, public router: Router)
    {
        this.settings = this.appSettings.settings;
    }

    ngOnInit()
    {
        // this.menuItems = this.menuService.getHorizontalMenuItems();
        this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId);
        console.log('HorizontalMenuComponent', this.menuItems)
    }

    ngAfterViewInit()
    {
        this.subscriptions.push(this.router.events.subscribe(event =>
        {
            if (event instanceof NavigationEnd)
            {
                if (this.settings.fixedHeader)
                {
                    let mainContent = document.getElementById('main-content');
                    if (mainContent)
                    {
                        mainContent.scrollTop = 0;
                    }
                }
                else
                {
                    document.getElementsByClassName('mat-drawer-content')[0].scrollTop = 0;
                }
            }
        }));
    }

    ngOnDestroy()
    {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}